import { Box, Typography } from '@mui/material'
import { Icon } from 'components'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CheckmarkCircle } from './checkmarkCircle'

type PasswordStrengthProps = {
  password?:       string
  passwordRepeat?: string
  onValidate?:     (valid: boolean) => void
}

export const PasswordStrength = ({
  password       = '',
  passwordRepeat = '',
  onValidate,
}: PasswordStrengthProps): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    const length    = password.length >= 6;
    const repeats   = passwordRepeat.length >= 6;
    const number    = /\d/.test(password);
    const matches   = length && repeats && password === passwordRepeat;
    const uppercase = /[A-Z]/.test(password);
    const lowercase = /[a-z]/.test(password);
    const specials  = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password);
    const valid =
      length && number && matches && uppercase && lowercase && specials;
    onValidate(valid);
  }, [password, passwordRepeat]);

  const length    = password.length >= 6;
  const repeats   = passwordRepeat.length >= 6;
  const number    = /\d/.test(password);
  const matches   = length && repeats && password === passwordRepeat;
  const uppercase = /[A-Z]/.test(password);
  const lowercase = /[a-z]/.test(password);
  const specials  = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password);
  const valid =
    length && number && matches && uppercase && lowercase && specials;

  let password_result = '';
  if (length && repeats && !matches) {
    password_result = t('password_miss_match');
  } else if (length && !valid) {
    password_result = t('password_not_valid');
  }

  return (
    <>
      <Box mt={3}>
        <Box gap={2} display='flex' alignItems='center' flexDirection='row'>
          <CheckmarkCircle variant={length ? 'success' : 'failure'} />
          <Typography variant='body1'>
            {t('password_strength_contains_six_characters')}
          </Typography>
        </Box>
        <Box gap={2} display='flex' alignItems='center' flexDirection='row'>
          <CheckmarkCircle variant={number ? 'success' : 'failure'} />
          <Typography variant='body1'>
            {t('password_strength_contains_number')}
          </Typography>
        </Box>
        <Box gap={2} display='flex' alignItems='center' flexDirection='row'>
          <CheckmarkCircle variant={matches ? 'success' : 'failure'} />
          <Typography variant='body1'>
            {t('password_strength_repeats_match')}
          </Typography>
        </Box>
        <Box gap={2} display='flex' alignItems='center' flexDirection='row'>
          <CheckmarkCircle variant={specials ? 'success' : 'failure'} />
          <Typography variant='body1'>
            {t('password_strength_contains_specials')}
          </Typography>
        </Box>
        <Box gap={2} display='flex' alignItems='center' flexDirection='row'>
          <CheckmarkCircle variant={lowercase ? 'success' : 'failure'} />
          <Typography variant='body1'>
            {t('password_strength_contains_lowercase')}
          </Typography>
        </Box>
        <Box gap={2} display='flex' alignItems='center' flexDirection='row'>
          <CheckmarkCircle variant={uppercase ? 'success' : 'failure'} />
          <Typography variant='body1'>
            {t('password_strength_contains_uppercase')}
          </Typography>
        </Box>
        <Typography>{password_result}</Typography>
      </Box>
    </>
  )
}
